import React from 'react';
import { ExternalLink, Handshake } from 'lucide-react';
import { partnerPortalLogin } from '../../config/partnerPortal';
import './PartnerSignIn.css';

interface PartnerSignInProps {
  text?: string;
  linkLabel?: string;
}

const PartnerSignIn: React.FC<PartnerSignInProps> = ({
  text = 'Channel partner?',
  linkLabel = 'Sign in to the partner portal',
}) => (
  <div className="partner-signin">
    <span className="partner-signin-icon" aria-hidden="true">
      <Handshake size={18} />
    </span>
    <p className="partner-signin-text">
      {text}
      <a
        className="partner-signin-link"
        href={partnerPortalLogin()}
        target="_blank"
        rel="noopener noreferrer"
      >
        {linkLabel}
        <ExternalLink size={13} className="partner-signin-external" aria-hidden="true" />
      </a>
    </p>
  </div>
);

export default PartnerSignIn;
